import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
function jsxN2br(text) {
    const lines = text.split('\n');
    if (lines.length <= 1) {
        return text;
    }
    return lines.map((line, i) => (_jsxs(Fragment, { children: [!!i && _jsx("br", {}, void 0), line] }, i)));
}
export function RenderLeafFallback({ leaf }) {
    let element = jsxN2br(leaf.text);
    if ('isCode' in leaf && leaf.isCode === true) {
        element = _jsx("code", { children: element }, void 0);
    }
    if ('isStruckThrough' in leaf && leaf.isStruckThrough === true) {
        element = _jsx("s", { children: element }, void 0);
    }
    if ('isHighlighted' in leaf && leaf.isHighlighted === true) {
        element = _jsx("em", { children: element }, void 0);
    }
    if ('isUnderlined' in leaf && leaf.isUnderlined === true) {
        element = _jsx("u", { children: element }, void 0);
    }
    if ('isItalic' in leaf && leaf.isItalic === true) {
        element = _jsx("i", { children: element }, void 0);
    }
    if ('isBold' in leaf && leaf.isBold === true) {
        element = _jsx("b", { children: element }, void 0);
    }
    return _jsx(_Fragment, { children: element }, void 0);
}
//# sourceMappingURL=RenderLeafFallback.js.map